var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.deviceInfo.mobile ? 'mobile-index' : '',attrs:{"id":"index"}},[_c('Header'),_c('img',{staticClass:"content1",attrs:{"src":"https://res.peki.vip/20240125/d7a78992e9d14b0892438aabb0d0a89e.png"}}),_c('img',{staticClass:"content2",attrs:{"src":"https://res.peki.vip/20240125/3b492de4d22d419d9216fddae55e249f.png"}}),_c('Fotter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }